import { useId } from 'react'
import type { Ref, TextareaHTMLAttributes } from 'react'
import styles from './ui.module.css'

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string
  hideLabel?: boolean
  ref?: Ref<HTMLTextAreaElement>
}

export function TextArea({ label, hideLabel = false, id, ...rest }: Props) {
  const generated = useId()
  const areaId = id ?? generated
  return (
    <div className={styles.field}>
      <label className={hideLabel ? 'dp-sr-only' : styles.label} htmlFor={areaId}>
        {label}
      </label>
      <textarea id={areaId} className={styles.textarea} {...rest} />
    </div>
  )
}
